
shadow.loader.set_load_start('code-editor');